'use strict';

bbw.model.ConversationMessage = Class({

    statics: {
        TYPE_INCOMING: 'incoming',
        TYPE_OUTGOUNG: 'outgoing',

        STATUS_NEW: 'new',
        STATUS_SENGIND: 'sending',
        STATUS_SENT: 'sent',
        STATUS_READ: 'read',
        STATUS_ERROR: 'error',

        STATUS_INCOMING: 'incoming',

        MSGTYPE_TEXT: 'msg',
        MSGTYPE_WINK: 'wink',
        MSGTYPE_DENY: 'deny',
        MSGTYPE_BAN: 'ban',

        areMessagesMergeble: function(msg1, msg2) {
            if (!msg1 || !msg2) {
                return false;
            }
            return msg1.message_type == bbw.model.ConversationMessage.MSGTYPE_TEXT &&
                msg2.message_type == bbw.model.ConversationMessage.MSGTYPE_TEXT &&
                msg1.status != bbw.model.ConversationMessage.STATUS_ERROR &&
                msg2.status != bbw.model.ConversationMessage.STATUS_ERROR &&
                msg1.is_from_history == msg2.is_from_history &&
                msg1.type == msg2.type &&
                (!msg1.photo_ids || !msg1.photo_ids.length) &&
                (!msg2.photo_ids || !msg2.photo_ids.length) &&
                Math.abs(msg2.timestamp - msg1.timestamp) < 60;
        },

        getSystemMessage: function(msg, user) {
            if (!msg || !msg.message_type) {
                return undefined;
            }
            if (angular.isDefined(msg.system_message)) {
                return msg.system_message;
            }
            var system_message = bbw.messages.chat[msg.message_type];
            if (angular.isDefined(system_message)) {
                if (angular.isObject(system_message)) {
                    system_message = system_message[msg.type];
                }
                if (!angular.isString(system_message)) {
                    system_message = null;
                } else {
                    system_message = ngtk.tools.string.parseTemplate(system_message, user, '{{', '}}', true);
                }
            } else {
                system_message = null;
            }
            return msg.system_message = system_message;
        },

        createText: function(to_user_id, message_text, photo_ids) {
            return new bbw.model.ConversationMessage(
                bbw.model.ConversationMessage.TYPE_OUTGOUNG,
                to_user_id,
                bbw.model.ConversationMessage.MSGTYPE_TEXT,
                message_text,
                photo_ids
            );
        },

        createWink: function(to_user_id) {
            return new bbw.model.ConversationMessage(
                bbw.model.ConversationMessage.TYPE_OUTGOUNG,
                to_user_id,
                bbw.model.ConversationMessage.MSGTYPE_WINK
            );
        },

        createIncoming: function(to_user_id, from_user_id, message_type, message_text, photo_ids, serial, timestamp) {
            return new bbw.model.ConversationMessage(
                bbw.model.ConversationMessage.TYPE_INCOMING,
                to_user_id,
                message_type,
                message_text,
                photo_ids,
                serial,
                timestamp,
                bbw.model.ConversationMessage.STATUS_INCOMING,
                from_user_id
            );
        },

        createOutgoing: function(to_user_id, from_user_id, message_type, message_text, photo_ids, serial, timestamp, is_read) {
            return new bbw.model.ConversationMessage(
                bbw.model.ConversationMessage.TYPE_OUTGOUNG,
                to_user_id,
                message_type,
                message_text,
                photo_ids,
                serial,
                timestamp,
                is_read ? bbw.model.ConversationMessage.STATUS_READ : bbw.model.ConversationMessage.STATUS_SENT,
                from_user_id
            );
        },

        createIncomingFromArgs: function(data) {
            return this.createIncoming(
                data.to_user_id,
                data.from_user_id,
                data.message_type,
                data.message_text,
                data.photo_ids,
                data.serial,
                data.timestamp
            );
        },

        createOutgoingFromArgs: function(data) {
            return this.createOutgoing(
                data.to_user_id,
                data.from_user_id,
                data.message_type,
                data.message_text,
                data.photo_ids,
                data.serial,
                data.timestamp,
                data.is_read
            );
        },

        createFromArgs: function(user_id, data) {
            if (user_id == data.from_user_id) {
                return bbw.model.ConversationMessage.createOutgoingFromArgs(data);
            } else {
                return bbw.model.ConversationMessage.createIncomingFromArgs(data);
            }
        },

        createFromHistoryRow: function(data, user_id) {
            var type = (user_id == data.to_user_id
                ? bbw.model.ConversationMessage.TYPE_OUTGOUNG
                : bbw.model.ConversationMessage.TYPE_INCOMING);
            return new bbw.model.ConversationMessage(
                type,
                data.to_user_id,
                data.message_type,
                data.message_text,
                data.photo_ids,
                data.serial,
                data.timestamp,
                type === bbw.model.ConversationMessage.TYPE_OUTGOUNG
                    ? (data.read_at ? bbw.model.ConversationMessage.STATUS_READ : bbw.model.ConversationMessage.STATUS_SENT)
                    : bbw.model.ConversationMessage.STATUS_INCOMING,
                data.from_user_id,
                true,
                data.photos
            );
        }
    },

    construct: function(type, to_user_id, message_type, message_text, photo_ids, serial, timestamp, status, from_user_id, is_from_history, photos) {
        if (!~[bbw.model.ConversationMessage.TYPE_INCOMING, bbw.model.ConversationMessage.TYPE_OUTGOUNG].indexOf(type)) {
            throw new Error("Invalid type argument: " + JSON.stringify(type));
        }
        message_text = message_text || '';
        angular.extend(this, {
            type: type,
            to_user_id: to_user_id,
            message_type: message_type,
            message_text: message_text,
            photo_ids: angular.isArray(photo_ids) ? photo_ids : [],
            status: status || (
                type === bbw.model.ConversationMessage.TYPE_OUTGOUNG
                    ? bbw.model.ConversationMessage.STATUS_NEW
                    : bbw.model.ConversationMesssage.STATUS_INCOMING
            ),
            serial: serial || null,
            timestamp: timestamp || null,
            from_user_id: from_user_id || null,
            is_from_history: !!is_from_history,
            photos: is_from_history ? photos : undefined
        });
    },

    getInverseContactRelationChange: function() {
        if (!this.isIncoming()) {
            return undefined;
        }
        switch (this.message_type) {
            case bbw.model.ConversationMessage.MSGTYPE_DENY:
                return 'denied';
            case bbw.model.ConversationMessage.MSGTYPE_BAN:
                return 'banned';
        }
        return undefined;
    },

    hasPhotosLoaded: function() {
        return angular.isDefined(this.photos);
    },

    canLoadPhotos: function() {
        return this.photo_ids.length > 0;
    },

    setPhotos: function(photos) {
        if (angular.isArray(this.photos)) {
            ngtk.tools.array.replace(this.photos, photos);
        } else {
            this.photos = angular.isArray(photos) ? photos : [];
        }

        return this;
    },

    setFromHistory: function(isFromHistory) {
        if (angular.isUndefined(isFromHistory)) {
            isFromHistory = true;
        }
        this.is_from_history = !!isFromHistory;

        return this;
    },

    isFromHistory: function() {
        return this.is_from_history;
    },

    isIncoming: function() {
        return this.type === bbw.model.ConversationMessage.TYPE_INCOMING;
    },

    isOutgoing: function() {
        return this.type === bbw.model.ConversationMessage.TYPE_OUTGOUNG;
    },

    prepareAndGetJsonToSend: function(from_user_id) {
        this.from_user_id = from_user_id;
        this.status = bbw.model.ConversationMessage.STATUS_SENGIND;
        return {
            to_user_id: this.to_user_id,
            message_type: this.message_type,
            message_text: this.message_text,
            photo_ids: this.photo_ids
        };
    },

    setSent: function(serial, timestamp) {
        this.serial = serial;
        this.timestamp = timestamp;
        this.status = bbw.model.ConversationMessage.STATUS_SENT;
    },

    setRead: function() {
        this.status = bbw.model.ConversationMessage.STATUS_READ;
    },

    setError: function(errorCode) {
        this.status = bbw.model.ConversationMessage.STATUS_ERROR;
        var tokens = errorCode.split(':');
        var error = tokens.shift();
        this.error = error;
        var message = bbw.messages.chat.errors[error];
        if (angular.isDefined(message)) {
            if (tokens.length) {
                tokens.unshift(message);
                this.error_message = ngtk.tools.string.format.apply(null, tokens);
            } else {
                this.error_message = message;
            }
        } else {
            this.error_message = bbw.messages.chat.errors.internal_error;
        }
    }

});
